export const constGridPaginatorOption = {
  maxSize: 1111111111,
  defaultPageSizeOption: [20, 50, 100],
  defaultPageSize: 20,
  defaultPageNo: 0,
  currentPageNo: 1,
  noRecordsMsg: 'No Records Found !',
  getAllRecordsPageNo: -1
};
